// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5376) return "static/chunks/5376-ebb23222d81049cd.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1761":"d0deef33","2084":"9b0008ae","6323":"5378cea6"}[chunkId] || chunkId) + "." + {"680":"819aa3ee53452dbc","1267":"e1ee0d68fda6b150","1761":"1fe3afdf5d5ad41b","2084":"1bac334dd453d790","6323":"c03f41343e08efb3","7159":"7ff53183c038effa","7496":"f4220189ea0ad3c7","7566":"4c15b736a102a7a2"}[chunkId] + ".js";
};